import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Dialog, FlatButton, Snackbar } from 'material-ui'
import { clearSnackbar } from '../../actions/snackbar'
import { clearDialog } from '../../actions/dialog'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {
  cyan500, cyan700,
  pinkA200,
  grey100, grey300, grey400, grey500,
  white,
  darkBlack, fullBlack
} from 'material-ui/styles/colors'
import { fade } from 'material-ui/utils/colorManipulator'
import spacing from 'material-ui/styles/spacing'

const brandColor = '#5391da'

const muiTheme = getMuiTheme({
  spacing: spacing,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: brandColor,
    primary2Color: cyan700,
    primary3Color: grey400,
    accent1Color: pinkA200,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: cyan500,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack
  }
})

class Wrapper extends Component<any, any> {
  render () {
    const actions = [
      <FlatButton
        label='Ok'
        primary
        onClick={this.props.onDialogClose}
      />
    ]

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          {this.props.children}
          <Snackbar
            message={this.props.snackbarMessage}
            open={this.props.snackbarOpen}
            onActionClick={this.props.onSnackbarClose}
            action='Dismiss'
            onRequestClose={this.props.onSnackbarClose}
            autoHideDuration={2000}
          />
          <Dialog
            title={this.props.dialogTitle}
            open={this.props.dialogOpen}
            actions={actions}
            onRequestClose={this.props.onDialogClose}
          >
            {this.props.dialogMessage}
          </Dialog>
        </div>
      </MuiThemeProvider>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    snackbarMessage: state.snackbar.message,
    snackbarOpen: !!state.snackbar.message,
    dialogTitle: state.dialog.title,
    dialogMessage: state.dialog.message,
    dialogOpen: !!state.dialog.message
  }
}

const mapDispatchToProps = (dispatch) => ({
  onSnackbarClose: () => {
    dispatch(clearSnackbar())
  },
  onDialogClose: () => {
    dispatch(clearDialog())
  }
})

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)
